import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './components/router/routes'
import store from './store/store'
import VueFlashMessage from 'vue-flash-message'
import VeeValidate from 'vee-validate';
import VuejsDialog from 'vuejs-dialog';
import UUID from 'vue-uuid';
import VueMeta from 'vue-meta'
//import Vuex from 'vuex'
//import BootstrapVue from 'bootstrap-vue'
/* import 'bootstrap/dist/css/bootstrap.css' */

/*** other packages */

//Vue.use(BootstrapVue)
//Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VuejsDialog)
Vue.use(VeeValidate)
Vue.use(VueFlashMessage)
Vue.use(UUID)
Vue.use(VueMeta)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
